export const gptContainerSx = (theme, height) => ({
  backgroundColor: theme.palette.background.secondary,
  color: theme.palette.secondary.main,
  borderRadius: '5px',
  padding: '12px',
  margin: '8px auto 0 auto',
  maxWidth: '345px',
  minHeight: height,
});
